import { render, staticRenderFns } from "./VipBlock.vue?vue&type=template&id=79783864"
import script from "./VipBlock.vue?vue&type=script&lang=js"
export * from "./VipBlock.vue?vue&type=script&lang=js"
import style0 from "./VipBlock.vue?vue&type=style&index=0&id=79783864&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports